<template>
  <div>
    <v-client-table key="pxGrid" class="hiaTable" ref="pxGrid" id="pxGrid" :data="worksheet.pxs" :columns="pxColumns" :options="options" uniqueKey="pxId">
      <template slot="originalPx" slot-scope="props">
        <div>
          <!-- <el-input style="width: 112px;" :inputId="`originalPx_${props.index}`" class="noRightBorder borderLeftRadius" v-model="props.row.originalPx" :disabled="disabled">
          </el-input> -->
          {{ props.row.originalPx }}
        </div>
      </template>

      <template slot="originalDescription" slot-scope="props">
        <div style="text-transform: lowercase;">
          {{ props.row.originalDescription }} <span v-if="props.row.originalGrouperFlags" :title="getGrouperflagsTitle(props.row.originalGrouperFlags)" class="grouperFlags">({{ props.row.originalGrouperFlags }})</span>
        </div>
      </template>

      <template slot="recommendedPx" slot-scope="props">
        <div>
          <!-- <el-input disabled style="width: 112px;" :placeholder="props.row.originalPx" :inputId="`recommendedPx_${props.index}`" :class="{deleteCode: props.row.deleteCode}"
            v-model="props.row.recommendedPx" @ellipsisClick="emitEllipsisClick(props.row.recommendedPx)" @focus="emitFocusedCode(props.row.recommendedPx)">
          </el-input> -->
          {{ props.row.recommendedPx }}
        </div>
      </template>

      <template slot="recommendedDesc" slot-scope="props">
        <div style="text-transform: lowercase;">
          {{ props.row.recommendedDesc }} <span :title="getGrouperflagsTitle(props.row.recommendedGrouperFlags)" v-if="(props.row.recommendedDx && props.row.recommendedGrouperFlags) || (props.row.recommendedGrouperFlags && props.row.recommendedGrouperFlags !== props.row.originalGrouperFlags)" class="grouperFlags">({{ props.row.recommendedGrouperFlags }})</span>
        </div>
      </template>

      <template slot="reasonForChange" slot-scope="props">
        {{ props.row.reasonForChange }}
      </template>

      <template slot="excluded" slot-scope="props">
        <div title="The recommendation is included for education purposes, but was not counted as an error in the coder's accuracy statistics" v-if="props.row.exclude" style="display: flex; padding: 3px; font-weight: normal;" class="el-alert el-alert--info is-light">
          <i class="el-icon el-icon-info" style="margin-right: 5px;"></i>
          <div>
            Excluded from Stats
          </div>
        </div>
      </template>

      <template slot="response" slot-scope="props">
        <el-button style="margin-right: 5px;" size="mini" v-if="(props.row.recommendedPx || props.row.originalDeleted) && !(worksheet.hideExcludedCodesResponseFromNucleus && props.row.exclude) && !(readOnly && embedded)" type="text" @click="addResponse(props.row)" :disabled="readOnly">Respond </el-button>
      </template>
    </v-client-table>
  </div>
</template>

<script>
import dateHelper from '@/mixins/date-helper'
import { format, parseISO } from 'date-fns'
import { mapMutations } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'

export default {
  name: 'coderInpatientPxs',
  mixins: [dateHelper, HiaAuthorization],
  props: ['worksheet', 'readOnly', 'embedded'],
  data() {
    return {
      format: format,
      parseISO: parseISO,
      disabled: true,
      loading: false,
      pxColumns: ['originalPx', 'originalDescription', 'recommendedPx', 'recommendedDesc', 'reasonForChange', 'excluded', 'response'],
      options: {
        filterable: false,
        filterByColumn: false,
        resizableColumns: false,
        queue: [],
        networkFunction: null,
        perPage: 100,
        rowClassCallback: row => {
          if (row.recommendedPx || row.deleteOriginal) {
            return 'highlight'
          }
          return ''
        },
        columnsClasses: {
          originalPx: 'tenPercent',
          originalDescription: 'thirtyFivePercent',
          recommendedPx: 'tenPercent',
          recommendedDescription: 'thirtyFivePercent',
          reasonForChange: 'tenPercent'
        },
        headings: {
          originalPx: 'Original Px',
          originalDescription: 'Desc.',
          recommendedPx: 'Recommended Px',
          recommendedDesc: 'Desc.',
          reasonForChange: 'Reason For Change',
          response: ''
        },
        customSorting: {
          originalPx: function(ascending) {},
          originalDescription: function(ascending) {},
          recommendedPx: function(ascending) {},
          recommendedDesc: function(ascending) {},
          reasonForChange: function(ascending) {},
          excluded: function(ascending) {},
          response: function(ascending) {}
        }
      }
    }
  },
  methods: {
    ...mapMutations('myProjects/', ['SET_RESPONSE_ROW']),
    getGrouperflagsTitle(flagList) {
      if (!flagList) {
        return
      }

      const flagMap = {
        AD: 'Affects DRG',
        CC: 'Complication/Comorbidity',
        HC: 'Hospital-Acquired Condition',
        MC: 'Complication/Comorbidity',
        R: 'Affects Risk of Mortality',
        S: 'Affects Severity of Illness',
        AP: 'Affects Patient Safety Indicators',
        EP: 'Excludes Patient Safety Indicators',
        AQ: 'Affects Quality Measures',
        EQ: 'Excludes Quality Measures',
        OR: 'Operative Procedure',
        NOR: 'Non-Operative Procedure'
      }

      const flags = flagList.split(',')
      const title = []
      flags.forEach(x => {
        title.push(`${x}: ${flagMap[x]}`)
      })

      return title.join('\n')
    },
    addResponse(row) {
      this.SET_RESPONSE_ROW(row)
    }
  }
}
</script>

<style scoped>
.grouperFlags {
  font-style: italic;
  text-transform: uppercase;
}

>>> .thirtyFivePercent {
  width: 30%;
}

>>> .highlight {
  /* background-color: rgba(255, 196, 12, 0.1) !important; */
  font-weight: bold;
}

>>> .highlight {
  border-left: 3px solid #f56c6c;
}

/* >>>.highlight:hover {
    background-color: rgba(255, 196, 12, 0.2) !important;
  } */

>>> td {
  font-size: 13px !important;
}

>>> .VuePagination__count {
  display: none;
}
</style>
